(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/assets/javascripts/views/betslip.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/assets/javascripts/views/betslip.js');

'use strict';

svs.keno.components.play.views.Betslip = Marionette.View.extend({
  viewOptions: ['showAccountSelector'],
  showAccountSelector: true,
  className: 'numbergames-footer col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4',
  regions: {
    rowPriceRegion: '#rowPriceRegion',
    drawCountRegion: '#drawCountRegion',
    accountSelectorRegion: '#accountSelectorRegion',
    trissRegion: '#trissRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.game.behaviors.teamSelectorAndSubscriptionInfo,
    accountSelectorRegionSelector: 'accountSelectorRegion'
  }],
  template(data) {
    return svs.keno.components.play.templates.betslip(data);
  },
  onRender() {
    var _this$model$get;
    const rules = svs.numbergames.rules.getRules({
      productId: svs.numbergames.productMapping.CONSTANTS.KENO
    });
    this.showChildView('rowPriceRegion', new svs.keno.components.play.views.RowPricePicker({
      model: this.model,
      rowPriceHeader: 'Insats per rad',
      possibleRowPrices: [{
        value: 1,
        label: '5 kr'
      }, {
        value: 2,
        label: '10 kr'
      }, {
        value: 4,
        label: '20 kr'
      }, {
        value: 6,
        label: '30 kr'
      }, {
        value: 8,
        label: '40 kr'
      }, {
        value: 10,
        label: '50 kr'
      }, {
        value: 20,
        label: '100 kr'
      }]
    }));
    this.showChildView('drawCountRegion', new svs.numbergames.game.views.DrawCount({
      model: this.model,
      drawCountHeader: 'Antal speldagar',
      possibleDrawCounts: [...rules.possibleDrawCounts]
    }));
    if ((_this$model$get = this.model.get('tickets')) !== null && _this$model$get !== void 0 && (_this$model$get = _this$model$get.at(0)) !== null && _this$model$get !== void 0 && _this$model$get.get('ticketData')) {
      this.showChildView('trissRegion', new svs.numbergames.game.views.Triss({
        model: this.model,
        productId: this.model.get('productId')
      }));
    }
  }
});

 })(window);